var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"time-zone-view"},[_c('div',{staticClass:"time-zone-view__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"time-zone-view__description"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }